/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/features/admin-business-profiles/components/business-profile-favorite-views-tab/business-profile-favorite-views-tab.component.scss */
/*# sourceMappingURL=business-profile-favorite-views-tab.component.css.map */
